var _path, _path2, _path3, _path4, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNetworkSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.39844,46.39844,33.459,47.459a9.2614,9.2614,0,0,1,13.082,0l1.06054-1.06054A10.76259,10.76259,0,0,0,32.39844,46.39844Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.39844,50.7417,37.459,51.80225a3.599,3.599,0,0,1,5.082,0l1.06054-1.06055A5.10016,5.10016,0,0,0,36.39844,50.7417Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.46973,42.44043,28.53027,43.501a16.2205,16.2205,0,0,1,22.93946,0l1.06054-1.06055a17.71994,17.71994,0,0,0-25.06054,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40,9.25A14.76686,14.76686,0,0,0,25.25,24v6.7005a22.75,22.75,0,1,0,29.5,0V24A14.76686,14.76686,0,0,0,40,9.25ZM26.75,24a13.25,13.25,0,0,1,26.5,0v5.52441a22.67367,22.67367,0,0,0-26.5,0Zm34.5,24A21.25,21.25,0,1,1,40,26.75,21.27376,21.27376,0,0,1,61.25,48Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 56,
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNetworkSecurity);
export default __webpack_public_path__ + "static/media/icon_network_security.5ab9009712831e680e83d0fe0553b52a.svg";
export { ForwardRef as ReactComponent };